import { localize } from '@vee-validate/i18n'
import en from '@vee-validate/i18n/dist/locale/en.json'
import sl from '@vee-validate/i18n/dist/locale/sl.json'
import {
    required,
    email,
    min,
    max,
    numeric,
    min_value,
    max_value,
    url, confirmed
} from '@vee-validate/rules'
import { defineRule, configure } from 'vee-validate'

defineRule('numeric', numeric)
defineRule('required', required)
defineRule('email', email)
defineRule('min', min)
defineRule('max', max)
defineRule('max', max)
defineRule('min_value', min_value)
defineRule('max_value', max_value)
defineRule('confirmed', confirmed)
defineRule('url', url)

defineRule('json', (value: string) => {
    try {
        if (value.length > 0) JSON.parse(value)
        return true
    } catch(error) {
        return false
    }
})

defineRule('at_least_one_uppercase', (value: string) => {
    const re = /[A-Z]/g
    return re.test(value)
})

defineRule('at_least_one_digit', (value: string) => {
    const re = /\d/g
    return re.test(value)
})

defineRule('taxNumberSI', (val: string) => {
    if (!val) {
        return false
    }

    val = val.toUpperCase()
    if (val.startsWith('SI', 0)) {
        val = val.slice(2)
    }

    if (!val || val.length !== 8) return false

    for (const c of val) {
        if (isNaN(Number(c))) return false
    }

    let sum = 0
    for (let i = 0; i < 7; i++) {
        sum += Number(val[i]) * (8 - i)
    }

    let control = 11 - (sum % 11)
    if (control === 10 || control === 11) control = 0

    return val[7] === String(control)
})

defineRule('taxNumberHR', (val: string) => {
    if (!val) return false

    val = val.toUpperCase().trim()
    if (val.startsWith('HR')) {
        val = val.slice(2)
    }

    if (!val || val.length !== 11 || !/^\d+$/.test(val)) return false

    let a = 10
    for (let i = 0; i < 10; i++) {
        a = (Number(val[i]) + a) % 10
        if (a === 0) a = 10
        a = (a * 2) % 11
    }

    const control = (11 - a) % 10

    return Number(val[10]) === control
})

configure({
    generateMessage: localize({
        en: {
            messages: {
                ...en.messages,
                at_least_one_uppercase: 'The {field} field must contain at least one uppercase letter',
                at_least_one_digit: 'The {field} field must contain at least one digit'
            }
        },
        sl: {
            messages: {
                ...sl.messages,
                at_least_one_uppercase: 'Polje {field} mora vsebovati vsaj eno veliko črko.',
                at_least_one_digit: 'Polje {field} mora vsebovati vsaj eno številko'
            }
        }
    })
})
